import { motion } from "framer-motion";
import companyLogo from "../assets/images/logo/light-logo-full.png";

const blinkAnimation = {
  animate: {
    opacity: [0.3, 1, 0.3],
    transition: {
      duration: 1.2,
      repeat: Infinity,
      ease: "easeInOut",
    },
  },
};

export default function LoadingOverlay({ show }) {
  if (!show) return null;

  return (
    <div className="fixed inset-0 z-[9999] bg-[#1b3144]/50 backdrop-blur-sm flex items-center justify-center">
      <motion.img
        src={companyLogo}
        alt="BroadBoy Adventures"
        className="w-40 md:w-52"
        variants={blinkAnimation}
        animate="animate"
      />
    </div>
  );
}
